export default {
    receiver: {
        title: 'Pedidos',
        subtitle: 'Gestiona tus pedidos enviados a expedidores',
        newOrder: 'Nuevo Pedido',
        tableTitle: 'Pedidos Enviados',
        tableDescription: 'Lista de todos los pedidos que has enviado a expedidores',
        headers: {
            orderId: 'ID de Pedido',
            shipper: 'Expedidor',
            targetWeek: 'Semana Objetivo',
            status: 'Estado',
            createdAt: 'Creado el',
            actions: 'Acciones'
        }
    },
    sender: {
        title: 'Pedidos',
        subtitle: 'Gestiona pedidos recibidos de destinatarios',
        tableTitle: 'Pedidos Recibidos',
        tableDescription: 'Lista de todos los pedidos recibidos de destinatarios',
        accept: 'Aceptar',
        reject: 'Rechazar',
        modify: 'Modificar',
        headers: {
            orderId: 'ID de Pedido',
            receiver: 'Destinatario',
            targetWeek: 'Semana Objetivo',
            status: 'Estado',
            createdAt: 'Creado el',
            actions: 'Acciones'
        }
    },
    list: {
        loading: 'Cargando pedidos...',
        noOrders: 'No se encontraron pedidos',
        searchPlaceholder: 'Buscar pedidos...',
        filters: {
            allStatuses: 'Todos los Estados'
        }
    },
    detail: {
        title: 'Detalles del Pedido',
        subtitle: 'Ver y gestionar detalles del pedido',
        loading: 'Cargando detalles del pedido...',
        notFound: 'Pedido no encontrado',
        backToList: 'Volver a la lista',
        back: 'Atrás',
        shipper: 'Expedidor',
        receiver: 'Destinatario',
        targetWeek: 'Semana Objetivo',
        createdAt: 'Creado el',
        respondedAt: 'Respondido el',
        notes: 'Notas',
        rejectionReason: 'Motivo del Rechazo',
        proposedChanges: 'Cambios Propuestos',
        modificationRequested: 'Solicitud de Modificación Enviada',
        modificationRequestedDescription: 'Has enviado una solicitud de modificación para este pedido. El Receiver recibirá una notificación y podrá aceptar o rechazar los cambios propuestos.',
        acceptChanges: 'Aceptar Cambios',
        acceptChangesAndResend: 'Aceptar Cambios y Reenviar Pedido',
        rejectChanges: 'Rechazar Cambios',
        changesAcceptedMessage: 'Los cambios han sido aceptados y el pedido ha sido reenviado al Shipper.',
        packingList: {
            title: 'Lista de Empaque',
            requested: 'Lista de Empaque Solicitada',
            provided: 'Lista de Empaque Proporcionada',
            notSpecified: 'No especificada',
            providePlaceholder: 'Ingresa la lista de empaque proporcionada...',
            save: 'Guardar Lista de Empaque'
        },
        contractualInfo: {
            title: 'Información Contractual',
            contractNumber: 'Número de Contrato',
            contractNumberPlaceholder: 'Ej. CONTRACT-2024-001',
            contractDate: 'Fecha del Contrato',
            terms: 'Términos',
            termsPlaceholder: 'Ingresa los términos del contrato...',
            notes: 'Notas del Contrato',
            notesPlaceholder: 'Notas adicionales sobre el contrato...',
            save: 'Guardar Información'
        },
        orderItems: {
            title: 'Detalles del Pedido del Cliente'
        },
        actions: {
            title: 'Acciones',
            accept: 'Aceptar Pedido',
            reject: 'Rechazar Pedido',
            modify: 'Proponer Cambios'
        },
        rejectModal: {
            title: 'Rechazar Pedido',
            reason: 'Motivo del Rechazo',
            reasonPlaceholder: 'Ingresa el motivo del rechazo...',
            submit: 'Confirmar Rechazo'
        },
        modifyModal: {
            title: 'Proponer Cambios',
            changes: 'Cambios Propuestos',
            changesPlaceholder: 'Describe los cambios que quieres proponer...',
            submit: 'Enviar Cambios'
        }
    },
    form: {
        title: 'Nuevo Pedido',
        subtitle: 'Crear un nuevo pedido para un remitente',
        back: 'Atrás',
        cancel: 'Cancelar',
        submit: 'Crear Pedido',
        saving: 'Guardando...',
        senderSection: 'Remitente',
        orderSection: 'Detalles del Pedido',
        sender: 'Remitente',
        senderPlaceholder: 'Selecciona un remitente',
        createNewSender: 'Crear Nuevo Remitente',
        newSenderName: 'Nombre del Remitente',
        newSenderNamePlaceholder: 'Ej. TechCorp Solutions LLC',
        newSenderEmail: 'Email del Remitente',
        newSenderEmailPlaceholder: 'contact@techcorp.com',
        newSenderCountry: 'País',
        newSenderCountryPlaceholder: 'Ej. Estados Unidos',
        createSender: 'Crear Remitente',
        shipperSection: 'Expedidor',
        shipper: 'Expedidor',
        shipperPlaceholder: 'Selecciona un expedidor',
        createNewShipper: 'Crear Nuevo Expedidor',
        newShipperName: 'Nombre del Expedidor',
        newShipperNamePlaceholder: 'Ej. TechCorp Solutions LLC',
        newShipperEmail: 'Email del Expedidor',
        newShipperEmailPlaceholder: 'contact@techcorp.com',
        newShipperCountry: 'País',
        newShipperCountryPlaceholder: 'Ej. Estados Unidos',
        createShipper: 'Crear Expedidor',
        targetWeek: 'Semana Objetivo',
        packingList: 'Lista de Empaque Solicitada',
        packingListPlaceholder: 'Describe en detalle la lista de empaque solicitada...',
        notes: 'Notas',
        notesPlaceholder: 'Notas adicionales sobre el pedido...',
        errors: {
            allFieldsRequired: 'Todos los campos obligatorios deben estar completos',
            newSenderNotImplemented: 'La creación de nuevos remitentes aún no está implementada. Por favor selecciona un remitente existente.',
            newShipperNotImplemented: 'La creación de nuevos expedidores aún no está implementada. Por favor selecciona un expedidor existente.',
            generic: 'Ocurrió un error al crear el pedido'
        }
    }
};

